import { PulseIcon } from '@icons';

const badgeClass = 'inline-flex items-center gap-[2px] shrink-0 bg-base-55 rounded py-[2px] pl-[2px] pr-1';
const labelClass = 'text-[10px] font-medium leading-none text-base-10 truncate max-w-[120px]';

type ClinicalDataBadgeProps = {
  title: string;
};

export const ClinicalDataBadge = ({ title }: ClinicalDataBadgeProps) => (
  <span className={badgeClass}>
    <PulseIcon />
    <span className={labelClass}>{title}</span>
  </span>
);
